import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle, Loader } from 'lucide-react';
import api from '../../lib/axios';
import { AuthShell } from './Login';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token    = params.get('token') || '';
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) { setStatus('error'); setMessage('Invalid link.'); return; }
    api.get(`/auth/verify-email?token=${token}`)
      .then(r => { setStatus('success'); setMessage(r.data.data.message); })
      .catch(e => { setStatus('error'); setMessage(e.response?.data?.error?.message || 'Verification failed.'); });
  }, [token]);

  return (
    <AuthShell title="Email verification" subtitle="">
      <div className="text-center py-8">
        {status === 'loading' && <Loader size={32} className="animate-spin text-primary mx-auto mb-4" />}
        {status === 'success' && (
          <>
            <div className="w-14 h-14 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle size={28} className="text-emerald-600" />
            </div>
            <h3 className="font-semibold text-ink mb-2">Email verified!</h3>
            <p className="text-sm text-ink-secondary mb-6">{message}</p>
            <Link to="/dashboard" className="btn-primary inline-flex">Go to dashboard</Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-14 h-14 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
              <XCircle size={28} className="text-red-500" />
            </div>
            <h3 className="font-semibold text-ink mb-2">Verification failed</h3>
            <p className="text-sm text-ink-secondary mb-6">{message}</p>
            <Link to="/login" className="btn-primary inline-flex">Back to login</Link>
          </>
        )}
      </div>
    </AuthShell>
  );
}
